import PropTypes from "prop-types";
import React from "react";

import { createClassNameString } from "../utils";

import "./styles.scss";

export const Image = ({ alt, className, onClick, src, ...props }) => (
  <img
    alt={alt}
    className={createClassNameString(["apti-CL apti-Image", className])}
    onClick={onClick}
    src={require(`../../assets/images/${src}`)}
    {...props}
  />
);

Image.propTypes = {
  alt: PropTypes.string.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
  src: PropTypes.string.isRequired,
};

Image.defaultProps = {
  alt: "image",
  className: undefined,
  onClick: () => {},
  src: undefined,
};
